<template>
  <button v-else @click="removeFilter()" type="button" class="filter mt-0">
    {{ this.translatedValue }}
    <span class="filter__close icon-close-big"></span>
  </button>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { ARTWORKS_FILTERS } from '../../../../consts';

  export default {
    name: 'ButtonForFiltersWithManyValues',
    props: {
      value: {
        type: String,
        required: true,
      },
      filterPath: {
        type: String,
        required: true,
      },
      filterName: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['filterValue']),
      currentArrayValue() {
        return this.filterValue(this.filterPath);
      },
      translatedValue() {
        if (this.filterName === ARTWORKS_FILTERS.CATEGORIES.NAME) {
          return this.I18n.t(`enums.artworks.categories.${this.value}`);
        }
        if (this.filterName === ARTWORKS_FILTERS.STATES.NAME) {
          return this.I18n.t(`search_page.artworks_tab.filters.state.values.${this.value}`);
        }
        if (this.filterName === ARTWORKS_FILTERS.PRICES.MODES.NAME) {
          return this.I18n.t(`search_page.artworks_tab.filters.price.modes.${this.value}`);
        }
        return this.value;
      },
    },
    methods: {
      ...mapActions(['getArtworksWhenFilterIsChanging']),
      removeFilter() {
        const arrayAfterValueRemoving = this.currentArrayValue.filter(
          elementValue => elementValue !== this.value,
        );
        this.getArtworksWhenFilterIsChanging(
          { path: this.filterPath, value: arrayAfterValueRemoving },
        );
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/active_filters_buttons/button_for_filters_with_many_values.vue?435f3b43